<mat-nav-list>
	<a mat-list-item routerLink="/" (click)="toggleSidenav.emit()">
		<mat-icon matListItemIcon svgIcon="home-solid" class="me-3"></mat-icon>
		<p matListItemLine class="app-sidenav__item mb-0" i18n>Startseite</p>
	</a>

	<mat-divider></mat-divider>

	<a mat-list-item routerLink="/search" (click)="toggleSidenav.emit()">
		<mat-icon matListItemIcon svgIcon="search-solid" class="me-3"></mat-icon>
		<p matListItemLine class="app-sidenav__item mb-0" i18n>Werkstoffe und Normen</p>
	</a>

	<mat-divider></mat-divider>

	<a mat-list-item routerLink="/static-page/contact" (click)="toggleSidenav.emit()">
		<mat-icon matListItemIcon svgIcon="contact" class="me-3"></mat-icon>
		<p matListItemLine class="app-sidenav__item mb-0" i18n>Kontakt</p>
	</a>

	<mat-divider></mat-divider>

	<a mat-list-item *ngIf="userInfo?.anonymous === false"
		 class="app-sidenav__user-full-name"
		 target="_blank" [href]="'change-password' | resourcePath" (click)="toggleSidenav.emit()">
		<mat-icon matListItemIcon svgIcon="person-solid" class="me-3"></mat-icon>
		<p matListItemLine class="app-sidenav__item mb-0">{{userInfo?.fullName}}</p>
	</a>

	<a mat-list-item *ngIf="userInfo?.groupAdminUrl as groupAdminUrl"
		 target="_blank" [href]="groupAdminUrl">
		<mat-icon matListItemIcon svgIcon="person-solid" class="me-3"></mat-icon>
		<p matListItemLine class="app-sidenav__item mb-0" i18n>Gruppenverwaltung</p>
	</a>

	<a mat-list-item *ngIf="userInfo?.anonymous === true" class="app-sidenav__login"
		 [href]="'login' | resourcePath" (click)="toggleSidenav.emit()">
		<mat-icon matListItemIcon svgIcon="person-solid" class="me-3"></mat-icon>
		<p matListItemLine class="app-sidenav__item mb-0" i18n>Login</p>
	</a>

	<mat-divider></mat-divider>

	<a mat-list-item *ngIf="userInfo?.hasExtendedAccess === true" class="app-sidenav__subscription-status"
		 [href]="'redirect-to-payment' | resourcePath" (click)="toggleSidenav.emit()">
		<mat-icon matListItemIcon svgIcon="lock-solid" class="me-3"></mat-icon>
		<p matListItemLine class="app-sidenav__item mb-0" i18n>Aboverwaltung</p>
	</a>

	<mat-divider></mat-divider>

	<a mat-list-item (click)="showLanguages.next(!showLanguages.value)">
		<mat-icon matListItemIcon svgIcon="globe-glyph" class="me-3"></mat-icon>
		<p matListItemLine class="app-sidenav__item mb-0" i18n>Sprache wählen</p>
	</a>

	<mat-divider></mat-divider>

	<div *ngIf="showLanguages.value">
		<a mat-list-item (click)="languageService.changeLanguage('de')">
			<p matListItemLine class="app-sidenav__icon-spacer app-sidenav__item mb-0">Deutsch</p>
		</a>

		<mat-divider></mat-divider>

		<a mat-list-item (click)="languageService.changeLanguage('en')">
			<p matListItemLine class="app-sidenav__icon-spacer app-sidenav__item mb-0">English</p>
		</a>

		<mat-divider></mat-divider>

		<a mat-list-item (click)="languageService.changeLanguage('es')">
			<p matListItemLine class="app-sidenav__icon-spacer app-sidenav__item mb-0">Español</p>
		</a>

		<mat-divider></mat-divider>

		<a mat-list-item (click)="languageService.changeLanguage('it')">
			<p matListItemLine class="app-sidenav__icon-spacer app-sidenav__item mb-0">Italiano</p>
		</a>

		<mat-divider></mat-divider>

		<a mat-list-item (click)="languageService.changeLanguage('fr')">
			<p matListItemLine class="app-sidenav__icon-spacer app-sidenav__item mb-0">Français</p>
		</a>
	</div>

	<mat-divider></mat-divider>

	<form *ngIf="userInfo?.anonymous === false" [action]="'logout' | resourcePath"
				class="app-sidenav__logout" #logoutForm>
		<a mat-list-item (click)="logoutForm.submit()">
			<mat-icon matListItemIcon svgIcon="material-logout" class="me-3"></mat-icon>
			<p matListItemLine class="app-sidenav__item mb-0" i18n>Logout</p>
		</a>
	</form>
</mat-nav-list>
